import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getInactiveShipList,
  getShipManagementDetails,
  getShipEquipmentDetails,
} from "../Actions/InactiveShipAPI";
import { getFlagList, getClassList } from "../Actions/helpersAPI";
import InactiveShipCard from "./InactiveShipCard";
import $ from "jquery";
import { FastForward } from "@material-ui/icons";
import i18n from "./DropdownLanguage/i18n";
let shipdata = {
  ShipName: "",
  ImoNo: "",
  Flag: "",
  Class: "",
  status: "Inactive",
  Grt: "",
  DeadWeight: "",
  PageNumber: 1,
  PageSize: 20,
};
class InactiveShipDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterShiplist: false,
      showSidePane: false,
      searchData: {
        ShipName: "",
        ImoNo: "",
        Flag: "",
        Class: "",
        Grt: "",
        status: "Inactive",
        DeadWeight: "",
        PageNumber: 1,
        PageSize: "20",
      },
    };
    this.SearchShip = this.SearchShip.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  componentDidMount() {
    const { dispatch, InactiveShipsearchData,t } = this.props;
    dispatch(getFlagList());
    dispatch(getClassList("class"));
    if (InactiveShipsearchData) {
      this.state.searchData = InactiveShipsearchData;
    }
    dispatch(getInactiveShipList(this.state.searchData));
    dispatch({ type: "SubBannerTitle", data: "Inactive Ships Dashboard" });
    let searchitem = this.state.searchData;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;
      // if (_this.verifySearchItems()
      //   // searchitem.ShipName ||
      //   // searchitem.ImoNo ||
      //   // searchitem.Flag ||
      //   // searchitem.Class ||
      //   // searchitem.Grt ||
      //   // searchitem.DeadWeight
      // ) {
      if (keycode === 13) {
        if (_this.verifySearchItems()) {
          _this.SearchShip(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  SearchShip(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    this.setState({}, () => {
      dispatch({ type: "InactiveShipsearchData", data: this.state.searchData });
      dispatch(getInactiveShipList(this.state.searchData));
    })

  }

  verifySearchItems = () => {
    // searchData: {
    //   ShipName: "",
    //   ImoNo: "",
    //   Flag: "",
    //   Class: "",
    //   Grt: "",
    //   status: "Inactive",
    //   DeadWeight: "",
    //   PageNumber: 1,
    //   PageSize: "20",
    // }
    let flag = true;
    const search = this.state.searchData;
    if (search.ShipName == "" && search.ImoNo == "" && search.Flag == "" && search.Class == "" && search.Grt == "" && search.DeadWeight == "") {
      flag = false;
    }
    return flag;
  }

  SearchShip1(pgno) {
    if (this.verifySearchItems()) {
      const { dispatch } = this.props;
      this.state.searchData.PageNumber = pgno;
      this.setState({}, () => {
        dispatch({ type: "InactiveShipsearchData", data: this.state.searchData });
        dispatch(getInactiveShipList(this.state.searchData));
      })
    }
    else {
      toast.success("Please select atleast one value", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

  }

  ClearInput() {
    const { dispatch } = this.props;
    let param = { ...shipdata };
    this.setState({ searchData: param }, () => {
      dispatch({ type: "InactiveShipsearchData", data: "" });
      dispatch(getInactiveShipList(param));
    });
    dispatch({ type: "InactiveShipsearchData", data: "" })


  }

  eyeclick(item) {
    const { dispatch } = this.props;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/InactiveShip/${item.shipId}`);
    dispatch(getShipManagementDetails(item.shipId));
    window.scrollTo(0, 0);
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }

  render() {
    const { InactiveShipsList, flagList, ClassList, t } = this.props;
    const isArabic = i18n.language === 'arab'
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          {t('InactiveShipScreenContent.InactiveShipSearch')}
                        </h5>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }>
                          <label className="form-label">{t('content.Shipname')}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="ShipName"
                            value={this.state.searchData.ShipName}
                            placeholder={t('content.Shipname')}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t('content.IMOno')}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="ImoNo"
                            value={this.state.searchData.ImoNo}
                            placeholder={t('content.IMOno')}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >

                          <label className="form-label">{t('TopPaneContent.Flag')}</label>
                          <br></br>
                          <select
                            className="form-control"
                            name="Flag"
                            value={this.state.searchData.Flag}
                            onChange={(e) => this.handleInputChange(e)}
                          >
                            <option value="">{t('ShipManagementContent.SelectFlag')}</option>
                            {flagList &&
                              flagList.map((flagname) => (
                                <option value={flagname}>{flagname}</option>
                              ))}
                          </select>
                        </div>
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t('TopPaneContent.Class')}</label>
                          <br></br>
                          <select
                            className="form-control"
                            name="Class"
                            value={this.state.searchData.Class}
                            onChange={(e) => this.handleInputChange(e)}
                          >
                            <option value="">{t('ShipManagementContent.SelectClass')}</option>
                            {ClassList &&
                              ClassList.map((classname) => (
                                <option value={classname}>{classname}</option>
                              ))}
                          </select>
                        </div>
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t('ShipManagementContent.GRT')}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="Grt"
                            placeholder={t('ShipManagementContent.GRT')}
                            value={this.state.searchData.Grt}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t('ShipManagementContent.DeadWeight')}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="DeadWeight"
                            placeholder={t('ShipManagementContent.DeadWeight')}
                            value={this.state.searchData.DeadWeight}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 mt-4">
                          <div
                            className="form-group search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchShip1(1)}
                            >
                              {" "}

                              {t('content.Search')}{" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              {t('content.Clear')}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {InactiveShipsList ? (
                <InactiveShipCard
                  currentPage={(InactiveShipsList.pagination.currentPage - 1) * InactiveShipsList.pagination.pageSize}
                  arraylist={InactiveShipsList}
                  currentPage={(InactiveShipsList.pagination.currentPage - 1) * InactiveShipsList.pagination.pageSize}
                  pageSize={InactiveShipsList.pagination.pageSize}
                  totalRecords={
                    InactiveShipsList.pagination.totalcount
                      ? InactiveShipsList.pagination.totalcount
                      : 0
                  }
                  setUpdatedState={(value) => this.SearchShip(value)}
                  eyeclick={(item) => this.eyeclick(item)}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    flagList: state.MasterScreenReducer.flagList,
    ClassList: state.MasterScreenReducer.ClassList,
    InactiveShipsList: state.MasterScreenReducer.InactiveShipsList,
    InactiveShipsearchData: state.SidePanReducer.InactiveShipsearchData,
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InactiveShipDashboard)
))

